/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OofOrderItemConfigurationDto } from './oofOrderItemConfigurationDto';


export interface ApplyToAllResultDto { 
    orderItemConfigs?: Array<OofOrderItemConfigurationDto>;
    orderItemStatus?: ApplyToAllResultDto.OrderItemStatusEnum;
}
export namespace ApplyToAllResultDto {
    export const OrderItemStatusEnum = {
        Incomplete: 'INCOMPLETE',
        Fulfilled: 'FULFILLED',
        Submitted: 'SUBMITTED',
        InProduction: 'IN_PRODUCTION',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        Canceled: 'CANCELED'
    } as const;
    export type OrderItemStatusEnum = typeof OrderItemStatusEnum[keyof typeof OrderItemStatusEnum];
}


export type OrderItemStatusEnum = typeof ApplyToAllResultDto.OrderItemStatusEnum[keyof typeof ApplyToAllResultDto.OrderItemStatusEnum];
